import React, { useCallback, useState, useMemo } from 'react';
import { useTranslation } from 'localization/useTranslation';
import { Modal, ModalVariant } from '@patternfly/react-core';
import SimpleTable, { RowSelection } from 'components/Common/SimpleTable/SimpleTable';
import { closeButton } from './ModalButtons';
import styles from './SelectedResourcesModal.module.css';
import { createRelation } from 'components/RelationTable/RelationTable';
import { OrgRelationAccess } from 'utils/types';

const SelectResourcesModal = ({ title, tableColumns, isOpen, onClose, available, orgId, updateRelationsFn }) => {
  const T = useTranslation();
  const [selected, setSelected] = useState([]);

  const _onClose = useCallback(() => {
    setSelected(null);
    onClose();
  }, [onClose]);

  const globalActions = useMemo(() => {
    return [
      {
        label: 'Viewer',
        onClick: () => {
          const relations = selected.map((row) => {
            return createRelation(orgId, row.id, row.type, OrgRelationAccess.viewer);
          });
          updateRelationsFn(relations);
        }
      },
      {
        label: 'Manager',
        onClick: () => {
          const relations = selected.map((row) => {
            return createRelation(orgId, row.id, row.type, OrgRelationAccess.manager);
          });
          updateRelationsFn(relations);
        }
      },
      {
        label: 'Owner',
        onClick: () => {
          const relations = selected.map((row) => {
            return createRelation(orgId, row.id, row.type, OrgRelationAccess.owner);
          });
          updateRelationsFn(relations);
        }
      }
    ];
  }, [orgId, selected, updateRelationsFn]);

  return (
    <Modal
      variant={ModalVariant.medium}
      className={styles.selectionModal}
      title={title}
      isOpen={isOpen}
      onClose={_onClose}
      actions={closeButton({ T, onClose: _onClose })}
    >
      <SimpleTable
        globalActions={globalActions}
        data={available}
        columns={tableColumns}
        rowSelection={RowSelection.MULTI_CHECKBOX}
        selectedRows={selected}
        onSelectedRows={setSelected}
        usePaging
        compact
      />
    </Modal>
  );
};

export default SelectResourcesModal;
